import { TextQuestion } from './TextQuestion';
import { ToggleQuestion } from './ToggleQuestion';
import { ChoiceQuestion } from './ChoiceQuestion';
import { CheckboxIcon, DropdownIcon, RadioButtonIcon, TextIcon, ToggleIcon } from './icons';

export const QuestionType = {
    TEXT: 'text',
    TOGGLE: 'toggle',
    DROPDOWN: 'dropdown',
    MULTIPLE_CHOICE: 'multiple_choice',

    // Unsupported by frontend:
    EXCLUSIVE_CHOICE: 'exclusive_choice',
};

export const FromJsonTypeMapping = {
    'multi': QuestionType.DROPDOWN,
    'checklist': QuestionType.MULTIPLE_CHOICE,
    'text': QuestionType.TEXT,
    'check': QuestionType.TOGGLE,
};

export const ToJsonTypeMapping = {
    [QuestionType.DROPDOWN]: 'multi',
    [QuestionType.MULTIPLE_CHOICE]: 'checklist',
    [QuestionType.TEXT]: 'text',
    [QuestionType.TOGGLE]: 'check',
};

export const QuestionTypeDefinition = {
    text: {
        icon: TextIcon,
        component: TextQuestion,
        props: {},
    },
    toggle: {
        icon: ToggleIcon,
        component: ToggleQuestion,
        props: {
        },
    },
    dropdown: {
        icon: DropdownIcon,
        component: ChoiceQuestion,
        props: {
            listTag: 'ol',
            showIcon: false,
            multiple: false,
        },
    },
    exclusive_choice: {
        icon: RadioButtonIcon,
        component: ChoiceQuestion,
        props: {
            listTag: 'ul',
            showIcon: true,
            addItemIcon: RadioButtonIcon,
            listItemIcon: RadioButtonIcon,
            multiple: false,
        },
    },
    multiple_choice: {
        icon: CheckboxIcon,
        component: ChoiceQuestion,
        props: {
            listTag: 'ul',
            showIcon: true,
            addItemIcon: CheckboxIcon,
            listItemIcon: CheckboxIcon,
            multiple: true,
        },
    },
};
